import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Switch, Route } from 'react-router-dom';
import { Row, Col } from 'react-bootstrap';
import { withTranslation } from 'react-i18next';
import { logoutUser } from '../auth/actions';
import routes, { submenus } from './routes';
import PageTitle from '../common/components/PageTitle';
import SideNav from './default/nav';
import Header from './default/header';
import { loadUnpagedCenters } from './centers/actions';
import { loadUnpagedTerms } from './terms/actions';

class Dashboard extends Component {

	constructor(props) {
		super(props);
		this.state = {
			showMobileNav: false,
			wideNav: true
		};
		this.handleMobileNavToggle = this.handleMobileNavToggle.bind(this);
		this.handleSideNavToggle = this.handleSideNavToggle.bind(this);
		this.handleToolsToggle = this.handleToolsToggle.bind(this);

		this.state = { showMobileNav: false, wideNav: true, showTools: false };
	}

	componentDidMount() {
		// init current user's data
		this.props.loadUnpagedCenters();
		this.props.loadUnpagedTerms();

		this.loadChat();
	}

	handleMobileNavToggle() {
		this.setState({ showMobileNav: !this.state.showMobileNav });
	}

	handleSideNavToggle() {
		this.setState({ wideNav: !this.state.wideNav, showMobileNav: false });
	}

	handleToolsToggle() {
		this.setState({ showTools: !this.state.showTools });
	}

	handleMenuItemClick() {
		const { showMobileNav } = this.state;
		if (showMobileNav) {
			this.setState({ showMobileNav: false });
		}
	}

	loadChat() {
		const { currentUser, franchisor } = this.props;
		if (!franchisor || !franchisor.enableSupportChatBot) {
			return;
		}

		const projectId = franchisor.supportChatBotProjectId || '690098907163963e6d4508b7'; 

		const scriptElement = document.createElement('script');
		scriptElement.async = true;
		scriptElement.text = `(function(d, t) {
		var v = d.createElement(t), s = d.getElementsByTagName(t)[0];
		v.onload = function() {
			window.voiceflow.chat.load({
				verify: { projectID: '${projectId}' },
				url: 'https://general-runtime.voiceflow.com',
				versionID: 'production',
				voice: {
					url: "https://runtime-api.voiceflow.com"
				},
				userID: ${currentUser.id},
				launch: {
					event: {
						type: "launch",
						payload: {
							user: {
								name: "${currentUser.screenName}",
								role: "${currentUser.role.name}"
							}
						}
					}
				}
			});
		}
		v.src = "https://cdn.voiceflow.com/widget-next/bundle.mjs"; v.type = "text/javascript"; s.parentNode.insertBefore(v, s);
	})(document, 'script');`;

		document.body.appendChild(scriptElement);
	}

	render() {
		const { currentUser, logoutUser, franchisor, t } = this.props;
		const { showMobileNav, wideNav, showTools } = this.state;

		const navClass = `${wideNav ? '' : 'navigation-small'} ${showMobileNav ? 'sidebar-mobile-open' : ''} ${showTools ? 'header-tools-open' : ''}`;

		return <div className={navClass}>
			<Header currentUser={currentUser} onLogout={logoutUser}
				onMobileNavToggle={this.handleMobileNavToggle}
				onSideNavToggle={this.handleSideNavToggle}
				onToolsToggle={this.handleToolsToggle}
			/>
			<div className='main-container'>
				<SideNav
					routes={routes}
					currentUser={currentUser}
					franchisor={franchisor}
					t={t}
					onMenuItemClick={() => this.handleMenuItemClick()}
				/>
				<div className='main-content'>
					<div className='container'>
						<Row>
							<Col sm={12}>
								<div className='page-header'>
									<Switch>
										{
											routes.map((route, index) => {
												const subRoutes = submenus[route.menuName];
												if (subRoutes) {
													return subRoutes.map((subRoute, subIndex) => {
														return (
															<Route key={subIndex} path={subRoute.path} exact={subRoute.exact} render={props => <PageTitle title={t(subRoute.pageTitleResourceKey)} />} />
														);
													});
												}

												return (
													<Route key={index} path={route.path} exact={route.exact} render={props => <PageTitle title={t(route.pageTitleResourceKey)} />} />
												);
											})
										}
									</Switch>
								</div>
							</Col>
						</Row>
						<Row>
							<Col sm={12}>
								<Switch>
									{
										routes.map((route, index) => {
											const subRoutes = submenus[route.menuName];
											if (subRoutes) {
												return subRoutes.map((subRoute) => {
													return (
														<Route path={subRoute.path} exact={subRoute.exact} component={subRoute.mainContent} />
													);
												});
											}

											return (
												<Route key={index} path={route.path} exact={route.exact} component={route.mainContent} />
											);
										})
									}
								</Switch>
							</Col>
						</Row>
					</div>
					<footer className='footer'>
						<p>Powered by <a href='https://bookingautopilot.com/'>Booking Autopilot</a> v{franchisor.assemblyVersion}</p>
					</footer>
				</div>
			</div>
		</div>;
	}
};

const mapStateToProps = state => ({
	currentUser: state.auth.currentUser,
	franchisor: state.configuration.franchisor
});

export default connect(mapStateToProps, {
	logoutUser,
	loadUnpagedCenters,
	loadUnpagedTerms
})(withTranslation()(Dashboard));